import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";

import barlowFont from "./../Barlow/Barlow-SemiBold.ttf";
import barlowFontRegular from "./../Barlow/Barlow-Regular.ttf";
import logo_constancia from "./../../../assets/iconos/logo_constancia.png";
import { formatterDate } from "../../../utils/Fechas/formatearFechas";

Font.register({ family: "Barlow", src: barlowFont });

Font.register({ family: "BarlowRegular", src: barlowFontRegular });

const FechaDescarga = () => {
  const date = new Date();
  const options = {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "numeric",
    hour12: true, // esta opción muestra la hora en formato de 12 horas
    timeZone: "America/Lima",
  };

  const formattedDate = date.toLocaleString("es-PE", options);

  return formattedDate;
};

const FechaFooter = (fecha) => {

  const options = { year: "numeric", month: "long", day: "numeric" };
  const date = new Date(fecha);
  const day = date.getDate().toString().padStart(2, '0');
  const month = new Intl.DateTimeFormat('es-PE', options).format(date).split(' ')[2];
  const year = date.getFullYear();
  return `${day} de ${month} de ${year}`;
};

const CronogramaDePago = ({ datatosConstacia, obtenerDatosEstudiante }) => {

  const { ndocidentidad, dfacultad, dprograma, dperiodo, dpersona, dciclo } =
    obtenerDatosEstudiante || {};

  const styles = StyleSheet.create({
    page: {
      padding: 40,
      height: "100%",
      position: "relative",
    },
    imageContainer: {
      height: "100px",
      width: "100%",

      display: "flex",
      flexDirection: "row",

      justifyContent: "center",
    },
    image: {
      width: "270px",
      height: "90px",
    },
    table: {
      alignItems: "center",
      display: "table",
      width: "auto",
      borderStyle: "solid",
      borderColor: "#aca9a9",
      borderWidth: 0.5,
      borderRightWidth: 0,
      borderBottomWidth: 0,
      fill: "#c7c7c7ed",
    },
    tableRow: {
      flexDirection: "row",
      display: "flex",
    },
    tableCol: {
      alignItems: "center",
      borderStyle: "solid",
      borderWidth: 0.5,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      borderColor: "#aca9a9",
      paddingTop: "5px",
      paddingBottom: "5px",
    },
    cabeceraTableCol: {
      alignItems: "left",
      borderStyle: "solid",
      borderWidth: 0.5,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      borderColor: "#aca9a9",
      width: "100%",
      wrap: "nowrap",
    },
    tableCell: {
      width: "100%",
      padding: "0 5px 0 5px",
      marginTop: 5,
      marginBottom: 5,
      fontSize: 9,
      textAlign: "left",
      marginVertical: 10,
      flexWrap: "wrap",
    },
    fontFamilys: {
      fontFamily: "BarlowRegular",
    },
    title: {
      textAlign: "center",
      fontWeight: "700",
      textTransform: "uppercase",
      fontFamily: "Barlow",
      fontSize: "15px",
    },
    titleRight: {
      textAlign: "right",
      marginTop: "10px",
      marginBottom: "10px",
      fontSize: "12px",
      fontFamily: "Barlow",
    },
    textUppercase: {
      textTransform: "uppercase",
    },
    textResumen: {
      fontSize: "10px",
      fontFamily: "Barlow",
    },
    textFooter: {
      fontSize: "10px",
      fontFamily: "Barlow",
    },
    textNormal: {
      fontFamily: "BarlowRegular",
    },
    paddingResunen: {
      padding: "15px 0 15px 0",
    },
    tarjetaResumen: {
      width: "120px",
      padding: "8px",
      border: "1.5px solid #adadad",
      borderRadius: "5px",
      marginRight: "10px",
      fontSize: "11px",
    },
    contentTarjeta: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",

      width: "100%",
    },
    footer: {
      width: "100%",
      textAlign: "center",
      position: "absolute",
      left: "10%",
      bottom: 25,
      fontFamily: "BarlowRegular",
      fontSize: "12px",
    },
    header: {
      width: "100%",
      textAlign: "center",
      position: "absolute",
      left: "10%",
      top: 25,
      fontFamily: "BarlowRegular",
      fontSize: "12px",
    },
    imgFirma: {
      width: "120px",
      height: "65px",
    },
  });

  const watermarkStyle = {
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    left: 50,
    position: "absolute",
    top: 0,
    width: "100%",

  };

  const textWatermarkStyle = {
    color: "rgba(0, 0, 0, 0.2)",
    fontSize: 80,
    fontFamily: "Barlow",
    fontWeight: 700,
    textTransform: "uppercase",
    transform: "rotate(-45deg)",
    userSelect: "none",
    textAlign: "center",
  };
  const paginate = (array = [], firstPageSize, restPageSize) => {
    const firstPage = array?.slice(0, firstPageSize);
    const restPages = array?.slice(firstPageSize);

    const restPagesResult = restPages?.reduce((result, item, index) => {
      const pageIndex = Math.floor(index / restPageSize);

      if (!result[pageIndex]) {

        result[pageIndex] = [];
      }
      result[pageIndex].push(item);
      return result;
    }, []);

    return [firstPage, ...restPagesResult];
  };

  const formatearDecimales = (number) => {
    const formatter = new Intl.NumberFormat("es-PE", {
      style: "currency",
      currency: "PEN",
      minimumFractionDigits: 2,
    });
    const formattedNumber = formatter.format(number).replace(/^(\D+)/, "");
    return formattedNumber;
  };

  const calculatePago = (TipoCalculate) => {
    let result = 0;

    for (const registro of datatosConstacia) {
      if ("deudas" === TipoCalculate) {
        result = result + registro.deudas;
      }
      if ("pagos" === TipoCalculate) {
        result = result + registro.pagos;
      }
      if ("saldo" === TipoCalculate) {
        result = result + registro.saldo;
      }
    }

    const formatResult = formatearDecimales(result);
    return formatResult;
  };

  return (
    <Document size="A4" key={"1a"}>
      {paginate(datatosConstacia, 7, 10)?.map((item, index) => {
        return (
          <Page style={styles?.page} key={index} wrap>
            <View fixed style={styles.header}>
              <Text style={{ textAlign: "left", fontSize: "10px" }}>
                {FechaDescarga()}
              </Text>
            </View>
            <View style={styles?.imageContainer}>
              <Image style={styles?.image} src={logo_constancia} />
            </View>
            {index == 0 && (
              <>
                <View>
                  <Text style={styles.title}>CRONOGRAMA DE PAGOS</Text>
                </View>
                <View
                  style={{
                    ...styles.textResumen,
                    marginTop: "15px",
                    marginBottom: "15px",
                  }}
                >
                  <Text style={styles.textResumen}>
                    Código Alumno:
                    <Text
                      style={{ ...styles.textNormal, textAlign: "justify" }}
                    >
                      {" "}
                      {ndocidentidad}
                    </Text>
                  </Text>
                  <Text style={styles.textResumen}>
                    Nombre Alumno:
                    <Text
                      style={{ ...styles.textNormal, textAlign: "justify" }}
                    >
                      {" "}
                      {dpersona}
                    </Text>
                  </Text>
                  <Text style={styles.textResumen}>
                    Facultad:
                    <Text
                      style={{ ...styles.textNormal, textAlign: "justify" }}
                    >
                      {" "}
                      {dfacultad}
                    </Text>
                  </Text>
                  <Text style={styles.textResumen}>
                    Programa:
                    <Text
                      style={{ ...styles.textNormal, textAlign: "justify" }}
                    >
                      {" "}
                      {dprograma}
                    </Text>
                  </Text>
                  <Text style={styles.textResumen}>
                    Nivel actual:
                    <Text
                      style={{ ...styles.textNormal, textAlign: "justify" }}
                    >
                      {" "}
                      {dciclo}
                    </Text>
                  </Text>
                </View>
              </>
            )}

            <View style={styles.textResumen}>
              <View style={styles.table}>
                <View style={{ ...styles.cabeceraTableCol }}>
                  <Text style={{ padding: "5px", textAlign: "left" }}>
                    AÑO {dperiodo}
                  </Text>
                </View>
                <View style={styles.tableRow}>
                  <View style={{ ...styles.tableCol, width: "10%" }}>
                    <Text style={{ ...styles.tableCell, margin: "auto" }}>
                      DOCUMENTO
                    </Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "12%" }}>
                    <Text style={{ ...styles.tableCell, margin: "auto" }}>
                      FECHA EMIS
                    </Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "12%" }}>
                    <Text style={{ ...styles.tableCell, margin: "auto" }}>
                      FECHA VCTO
                    </Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "11%" }}>
                    <Text style={{ ...styles.tableCell, margin: "auto" }}>
                      PAGO BANCO/CAJA
                    </Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "12%" }}>
                    <Text style={{ ...styles.tableCell, margin: "auto" }}>
                      CONCEPTO
                    </Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "6%" }}>
                    <Text style={{ ...styles.tableCell, margin: "auto" }}>
                      MON.
                    </Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "10%" }}>
                    <Text style={{ ...styles.tableCell, margin: "auto" }}>
                      DEUDAS
                    </Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "9%" }}>
                    <Text style={{ ...styles.tableCell, margin: "auto" }}>
                      PAGOS
                    </Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "9%" }}>
                    <Text style={{ ...styles.tableCell, margin: "auto" }}>
                      SALDOS
                    </Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "9%" }}>
                    <Text style={{ ...styles.tableCell, margin: "auto" }}>
                      OBS.
                    </Text>
                  </View>
                </View>
                {item.map((item2, index2) => {
                  return (
                    <View key={index2} style={styles.tableRow}>
                      <View style={{ ...styles.tableCol, width: "10%" }}>
                        <Text
                          style={{
                            ...styles.tableCell,
                            ...styles.fontFamilys,
                            margin: "auto",
                          }}
                        >
                          {/* I0853 */}
                          {item2.documento}
                        </Text>
                      </View>
                      <View style={{ ...styles.tableCol, width: "12%" }}>
                        <Text
                          style={{
                            ...styles.tableCell,
                            ...styles.fontFamilys,
                            margin: "auto",
                          }}
                        >
                          {/* 1 */}
                          {formatterDate(item2.femision)}
                        </Text>
                      </View>
                      <View style={{ ...styles.tableCol, width: "12%" }}>
                        <Text
                          style={{
                            ...styles.tableCell,
                            ...styles.fontFamilys,
                            margin: "auto",
                          }}
                        >
                          {/* MATEMATICAS BASICAS */}
                          {formatterDate(item2.fvecimiento)}
                        </Text>
                      </View>
                      <View style={{ ...styles.tableCol, width: "11%" }}>
                        <Text
                          style={{
                            ...styles.tableCell,
                            ...styles.fontFamilys,
                            margin: "auto",
                          }}
                        >
                          {/* 4 */}
                          {item2.banco}
                        </Text>
                      </View>
                      <View style={{ ...styles.tableCol, width: "12%" }}>
                        <Text
                          style={{
                            ...styles.tableCell,
                            ...styles.fontFamilys,
                            margin: "auto",
                          }}
                        >
                          {/* 1 */}
                          {item2.concepto}
                        </Text>
                      </View>
                      <View style={{ ...styles.tableCol, width: "6%" }}>
                        <Text
                          style={{
                            ...styles.tableCell,
                            ...styles.fontFamilys,
                            margin: "auto",
                          }}
                        >
                          {/* 1 */}
                          {item2.moneda}
                        </Text>
                      </View>
                      <View style={{ ...styles.tableCol, width: "10%" }}>
                        <Text
                          style={{
                            ...styles.tableCell,
                            ...styles.fontFamilys,
                            margin: "auto",
                          }}
                        >
                          {/* 1 */}
                          {formatearDecimales(item2.deudas)}
                        </Text>
                      </View>
                      <View style={{ ...styles.tableCol, width: "9%" }}>
                        <Text
                          style={{
                            ...styles.tableCell,
                            ...styles.fontFamilys,
                            margin: "auto",
                          }}
                        >
                          {/* 1 */}
                          {formatearDecimales(item2.pagos)}
                        </Text>
                      </View>
                      <View style={{ ...styles.tableCol, width: "9%" }}>
                        <Text
                          style={{
                            ...styles.tableCell,
                            ...styles.fontFamilys,
                            margin: "auto",
                          }}
                        >
                          {/* 1 */}
                          {formatearDecimales(item2.saldo)}
                        </Text>
                      </View>
                      <View style={{ ...styles.tableCol, width: "9%" }}>
                        <Text
                          style={{
                            ...styles.tableCell,
                            ...styles.fontFamilys,
                            margin: "auto",
                          }}
                        >
                          {/* 1 */}
                          {item2.obs}
                        </Text>
                      </View>
                    </View>
                  );
                })}
                <View style={styles.tableRow}>
                  <View style={{ ...styles.cabeceraTableCol, width: "63%" }}>
                    <Text
                      style={{
                        padding: "5px",
                        textAlign: "left",
                        margin: "auto",
                      }}
                    >
                      Total documentos
                    </Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "10%" }}>
                    <Text style={{ ...styles.tableCell, margin: "auto" }}>
                      {calculatePago("deudas")}{" "}
                    </Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "9%" }}>
                    <Text style={{ ...styles.tableCell, margin: "auto" }}>
                      {calculatePago("pagos")}
                    </Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "9%" }}>
                    <Text style={{ ...styles.tableCell, margin: "auto" }}>
                      {calculatePago("saldo")}
                    </Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "9%" }}>
                    <Text
                      style={{ ...styles.tableCell, margin: "auto" }}
                    ></Text>
                  </View>
                </View>{" "}
              </View>
            </View>
            <View style={styles.footer} fixed>
              <Text style={{ width: "100%", fontSize: "10px" }}>
                Av. Honorio Delgado 430, Urbanización Ingeniería, San Martín de
                Porres
              </Text>
              <Text style={{ width: "100%", ...styles.textFooter }}>
                www.upch.edu.pe
              </Text>

              <Text
                style={{ textAlign: "right", fontSize: "10px" }}
                render={({ pageNumber, totalPages }) =>
                  `${pageNumber} / ${totalPages}`
                }
                fixed
              />
            </View>
          </Page>
        );
      })}
    </Document>
  );
};

export default CronogramaDePago;
